
/**
 * A helper function to make HTTP requests.
 *
 * @param {string} url - The URL to send the request to.
 * @param {string} [method='GET'] - The HTTP method to use (GET, POST, etc.).
 * @param {Object|null} [body=null] - The body of the request, if applicable.
 * @param {string|null} [token=null] - The authorization token for the request.
 * @param {string} [contentType='application/json'] - The content type of the request.
 * @param {Object} [params={}] - An object representing query parameters to be appended to the URL.
 * @returns {Promise<Object>} - A promise that resolves to the response data.
 * @throws {Error} - Throws an error if the request fails or if the response is not ok.
 */
const httpHelper = async (url, method = 'GET', body = null, token = null, contentType = 'application/json', params = {}) => {
    // Construct query string from params

    const queryString = new URLSearchParams(params).toString();

    const finalUrl = method === 'GET' && queryString ? `${url}?${queryString}` : url;

    const headers = {
        'Content-Type': contentType,
    };

    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    const options = {
        method,
        headers,
    };

    if (body) {
        options.body = JSON.stringify(body);
    }

    try {

        const response = await fetch(finalUrl, options);

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'Something went wrong');
        }

        return await response.json();
    } catch (error) {
        console.error('HTTP Error:', error);
        throw error; // Rethrow the error for further handling
    }
};

export const Method_TYPE = {
    'GET': 'GET',
    'PUT': 'PUT',
    'POST': 'POST',
    'DELETE': 'DELETE',
    'PATCH': 'PATCH',
    'HEAD': 'HEAD',
    'OPTIONS': 'OPTIONS'
};
export default httpHelper;